import React from 'react';
import { SectionReveal } from '../SectionReveal';
import { BONOS } from '../../data/content';
export function Bonos() {
  return <section className="w-full bg-carbon" aria-labelledby="bonos-heading" data-id="element-40">
      <SectionReveal className="mx-auto w-full max-w-3xl px-5 py-16 sm:py-20" data-id="element-41">
        <h2 id="bonos-heading" className="mb-3 text-center font-heading text-2xl font-bold uppercase tracking-tight text-soft sm:text-3xl" data-id="element-42">
          🎁 3 Bonos incluidos siempre
        </h2>
        <p className="mb-8 text-center text-muted" data-id="element-43">
          Sumados a los 6 tomos, sin costo extra.
        </p>

        <ul className="overflow-hidden rounded-lg border border-gold-tenue" data-id="element-44">
          {BONOS.map((bono, i) => <li key={bono.number} className={`flex flex-col gap-3 p-5 sm:flex-row sm:items-center sm:justify-between ${i % 2 === 0 ? 'bg-carbon-2' : 'bg-carbon-3'}`} data-id="element-45">
              <div className="min-w-0" data-id="element-46">
                <span className="font-heading text-xs font-bold uppercase tracking-wide text-orange" data-id="element-47">
                  {bono.number}
                </span>
                <span className="mt-1 block break-words font-heading font-bold text-soft" data-id="element-48">
                  {bono.title}
                </span>
                <span className="mt-1 block break-words text-sm text-muted" data-id="element-49">
                  {bono.description}
                </span>
              </div>
              <div className="flex flex-none items-center gap-3 sm:flex-col sm:items-end sm:gap-0.5" data-id="element-50">
                <span className="text-sm text-muted line-through" data-id="element-51">
                  {bono.value}
                </span>
                <span className="font-heading text-base font-bold text-emerald" data-id="element-52">
                  🎁 GRATIS
                </span>
              </div>
            </li>)}
        </ul>
      </SectionReveal>
    </section>;
}